export default __webpack_public_path__ + "static/media/bmb-2-l.b568c92a.png";